export const dataTypes = [
  { id: 'int', title: 'Integer' },
  { id: 'float', title: 'Float' },
  { id: 'str', title: 'String' },
  { id: 'bool', title: 'Boolean' },
  { id: 'list', title: 'List' },
  { id: 'text', title: 'Text' }
];

export const PAGES = {
  MAIN_PAGE: 'mainPage',
  VALUE_PAGE: 'valuePage'
};
